module.exports = __webpack_public_path__ + "static/media/ehealth-bg3-16-9.c6078a63.jpg";